import { render, staticRenderFns } from "./EmployeePause.vue?vue&type=template&id=230a3549&"
import script from "./EmployeePause.vue?vue&type=script&lang=js&"
export * from "./EmployeePause.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePause.vue?vue&type=style&index=0&id=230a3549&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports